// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "carbon-lab." + {"29":"c42fcf78f8","306":"9479afe673","526":"ca8df0b93b","962":"6a5d4ccddc","966":"e26718d6b4"}[chunkId] + "." + chunkId + ".chunk.js";
};